type AppRequestResponse = {
  outcome?: string;
  message?: string;
  job_id?: string;
  discovery_id?: string;
  candidates?: unknown[];
};

export function appRequestOutcome(data: AppRequestResponse | null | undefined):
  "completed" | "suggestions" | "job_started" | null {
  if (data?.outcome === "responded" || data?.outcome === "clarification_required") {
    return "completed";
  }
  if (data?.outcome === "agentic_flow_suggestions") {
    return typeof data.discovery_id === "string" && data.discovery_id.length > 0 &&
        Array.isArray(data.candidates) && data.candidates.length > 0
      ? "suggestions"
      : null;
  }
  return typeof data?.job_id === "string" && data.job_id.length > 0
    ? "job_started"
    : null;
}
